// Il mese di riferimento è quello di Roma, indipendentemente dal fuso del browser.
export function dateSpedizioniInStallo(now = new Date()) {
  const parts = new Intl.DateTimeFormat("en-GB", {
    timeZone: "Europe/Rome",
    year: "numeric",
    month: "2-digit",
  }).formatToParts(now);
  const year = Number(parts.find((part) => part.type === "year").value);
  const month = Number(parts.find((part) => part.type === "month").value);

  // Aritmetica di calendario in UTC, senza conversioni di mezzanotte locale.
  return {
    dataDa: new Date(Date.UTC(year, month - 4, 1)).toISOString().slice(0, 10),
    dataA: new Date(Date.UTC(year, month - 1, 0)).toISOString().slice(0, 10),
  };
}
